<div class="zk-flex md:zk-flex-row sm:zk-flex-col" *ngIf="isPremium">
	<div class="speech-to-text-label zk-flex zk-items-center zk-gap-2 zk-w-full sm:zk-justify-center md:zk-justify-start">
		<div class="zk-flex zk-items-center">
			<p>{{'PROMPTUARY.SPEECH_TO_TEXT.LABEL' | translate}}</p>
		</div>
		<div class="zk-flex zk-items-center">
			<span freud-tooltip class="zk-flex zk-items-center" [tooltipLabel]="'PROMPTUARY.SPEECH_TO_TEXT.INFO' | translate" tooltipPosition="top">
				<span class="freud-icon freud-icon-info-circle freud-icon-xs zk-flex zk-items-center"></span>
			</span>
		</div>
	</div>
	<div class="zk-flex zk-items-center zk-justify-end sm:zk-justify-center md:zk-justify-end">
		<button
			type="button"
			class="btn speech-to-text-btn init-btn btn-md"
			(click)="init()"
			[disabled]="initButtonDisabled"
		>
			<span class="freud-icon freud-icon-microphone"></span> {{initButtonLabel}}
		</button>
		<button
			type="button"
			class="btn speech-to-text-btn stop-btn btn-md"
			(click)="stop()"
			[disabled]="stopButtonDisabled"
		>
			<span class="freud-icon freud-icon-microphone-off"></span> {{stopButtonLabel}}
		</button>
	</div>
</div>
